import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { AppBar, Hidden, IconButton, Toolbar, makeStyles, Popper } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import InputIcon from "@material-ui/icons/Input";
import { Logo, Typography } from "@packages/ui";

import * as authActions from "src/actions/authActions";
import getBrandFromUrl from "../../utils/getBrandFromUrl";

const brand = getBrandFromUrl();

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    borderBottom: `5px solid ${theme.palette.primary.main}`,
    zIndex: 100,
  },
  logo: {
    marginTop: 5,
    height: brand === "Ace" ? "50px" : brand === "Firefly" ? "45px" : brand ==="Dollar" ? "45px" : brand =="Thrifty" ? "45px" : "32px",
  },
  center: {
    flexGrow: 1,
    align: "center",
  },
  popper: {
    backgroundColor: "white",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "-10px",
      right: "30px",
      borderBottom: `10px solid ${theme.palette.primary.main}`,
      borderRight: "5px solid transparent",
      borderLeft: "5px solid transparent",
    },
  },
  popperText: {
    padding: 8,
    maxWidth: 125,
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 3,
  },
}));

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const open = useSelector((state) => state.app.popper);
  const [el, setEl] = useState(null);

  function logout() {
    dispatch(authActions.logout());
    return <Navigate to="/login" />;
  }

  return (
    <AppBar className={clsx(classes.root, className)} elevation={0} {...rest}>
      <Toolbar>
        <RouterLink to="/app/rentalhistory" className={classes.center}>
          <Logo brand={brand} className={classes.logo} />
        </RouterLink>
        <Hidden mdDown>
          <Typography variant={"h3"}>My Journey Portal</Typography>
        </Hidden>
        <Hidden lgUp>
          <Typography variant={"h5"}>My Journey Portal</Typography>
        </Hidden>
        <Hidden mdDown>
          <IconButton onClick={() => logout()}>
            <InputIcon />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton
            aria-describedby={"simple-popover"}
            ref={setEl}
            onClick={onMobileNavOpen}
            style={{ zIndex: 10000 }}
          >
            <MenuIcon />
          </IconButton>
          <Popper
            id={"simple-popover"}
            open={el !== null && open}
            anchorEl={el}
            anchororigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformorigin={{
              vertical: "top",
              horizontal: "left",
            }}
            className={classes.popper}
            style={{ zIndex: 500 }}
          >
            <Typography className={classes.popperText}>Click to view the menu</Typography>
          </Popper>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

export default TopBar;